import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-left mt20" }
const _hoisted_2 = { class: "posRe" }
const _hoisted_3 = { class: "fl" }
const _hoisted_4 = {
  class: "circleBlueButton pointer selected mr10",
  style: {"top":"-10px","left":"10px","font-size":"17px"}
}
const _hoisted_5 = {
  key: 0,
  class: "mt3 ml6"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "circleBlueButton pointer fl ofh",
  style: {"border-radius":"50%"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "fl"
}
const _hoisted_11 = { class: "fl" }
const _hoisted_12 = {
  class: "fl",
  style: {"width":"200px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "fs11" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { class: "fl ml10" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = {
  key: 2,
  class: "fr",
  style: {"width":"160px"}
}
const _hoisted_20 = {
  key: 0,
  class: "fs12"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "rad20 borderGrey w60 fl pad10"
}
const _hoisted_24 = {
  key: 0,
  id: "account_members"
}
const _hoisted_25 = ["value"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(`${_ctx.selectedMember ? `w100` : `w30`} rad20 pad20 borderGrey fl mr20`)
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.mag.name), 1),
          (_ctx.Util.isPresent(_ctx.mag.required_attendees))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives(_createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_circle.png`),
                  width: "18",
                  height: "18"
                }, null, 8, _hoisted_6), [
                  [_directive_tooltip, `連携している外部カレンダー\n${_ctx.mag.required_attendees.map(m => m.name).join(`\n`)}`]
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.hasProfile(_ctx.mag))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.mag.profile_image_urls && _ctx.mag.profile_image_urls[0])
                ? (_openBlock(), _createBlock(_component_UserIcon, {
                    key: 0,
                    imageUrl: _ctx.mag.profile_image_urls[0],
                    canEdit: false,
                    updateSelf: false,
                    width: 45,
                    style: {"margin-left":"-1px"}
                  }, null, 8, ["imageUrl"]))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
                    width: "45",
                    height: "45"
                  }, null, 8, _hoisted_8)),
              _hoisted_9
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedMember)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_UserIcon, {
                  member: _ctx.selectedMember.user,
                  width: 45,
                  canEdit: false,
                  updateSelf: false,
                  showTooltip: false,
                  class: "fl mr6 ml20"
                }, null, 8, ["member"]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.selectedMember.user.name), 1),
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.selectedMember.user.email), 1)
                ]),
                _hoisted_15
              ]),
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                  width: "24",
                  class: "pointer",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.disconnect && _ctx.disconnect(...args)))
                }, null, 8, _hoisted_17), [
                  [_directive_tooltip, `アカウント連携を解除`]
                ])
              ]),
              _hoisted_18
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedMember)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_ctx.Util.isBlank(_ctx.selectedMember.line_instant_room_assigned_user_id))
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, " 保存後、有効にできるようになります。 "))
                : _withDirectives((_openBlock(), _createBlock(_component_Switcher, {
                    key: 1,
                    value: "type[is_active]",
                    name: "設定の有効",
                    checked: _ctx.isActive,
                    display: "true",
                    class: "checkUsingCal fr posAb",
                    onSelect: _ctx.changeActive
                  }, null, 8, ["checked", "onSelect"])), [
                    [_directive_tooltip, `設定を${_ctx.isActive ? `無効` : `有効`}にします`]
                  ]),
              _hoisted_21
            ]))
          : _createCommentVNode("", true),
        _hoisted_22
      ], 2),
      (!_ctx.selectedMember)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(_component_TextfieldTag, {
              placeholder: "紐付けるメンバーのメールアドレス",
              style: {"height":"36px","width":"200px"},
              class: "cal_blanks fw600 fl fs12",
              list: "account_members",
              id: "connect_member",
              value: _ctx.connectEmail,
              onInputValue: _ctx.inputEmail
            }, null, 8, ["value", "onInputValue"]),
            (_ctx.members)
              ? (_openBlock(), _createElementBlock("datalist", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (mem, memindex) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: memindex,
                      value: mem.email
                    }, _toDisplayString(mem.email), 9, _hoisted_25))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "fl greyBg rad5 mt16 fs11 pointer hoverGreyBg",
              style: {"padding":"13px","height":"40px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.connectMember && _ctx.connectMember(...args)))
            }, " 紐付け "),
            _hoisted_26
          ]))
        : _createCommentVNode("", true),
      _hoisted_27
    ])
  ]))
}